export const groupTable = function () {
  return {
    index: true,
    indexLabel: "序号",
    highlightCurrentRow: true,
    maxHeight: "100%",
    column: [
      {
        label: "群组名称",
        prop: "personnelGroupName",
        search: true,
        clearable: true
      }
    ]
  };
};
